import SaadaFirstCharge from '../pages/saada/FirstCharge/reducers'
import SaadaBDCenter from '../pages/saada/BD/pages/center/reducers'
import SaadaUnionCenter from '../pages/saada/Union/pages/center/reducers'
import SaadaUnionExportRevenue from '../pages/saada/Union/pages/exportRevenue/reducers'
import SaadaUnionDeleteAnchor from '../pages/saada/Union/pages/deleteAnchor/reducers'
import SaadaUnionAnchorInvite from '../pages/saada/Union/pages/anchorInvite/reducers'
import SaadaAnchorGuideCenter from '../pages/saada/Anchor/pages/guideCenter/reducers'
import SaadaAnchorJoinUnion from '../pages/saada/Anchor/pages/joinUnion/reducers'
import SaadaWalletHome from '../pages/saada/Wallet/pages/home/reducers'
import SaadaWalletOutCash from '../pages/saada/Wallet/pages/outCash/reducers'
import SaadaUnionWelcome from '../pages/saada/UnionWelcome/reducers'
import CertificationAppeals from '~/pages/saada/CertificationAppeals/reducers'
import SaadaLevelCenter from '../pages/saada/levelCenter/reducers'
import SaadaChatIncome from '../pages/saada/chatIncome/reducers'
import SaadaChatRank from '../pages/saada/ChatRank/reducers'
import SaadaRecScore from '../pages/saada/RecScore/reducers'
import SaadaAgency from '../pages/saada/Agency/reducers'
import SaadaAnonymousMatching from '../pages/saada/AnonymousMatching/reducers'
import SaadaFemaleUserWelcome from '../pages/saada/FemaleUser/reducers'
import SaadaCoinAgencyWallet from '../pages/saada/Coinagency/AgencyWallet/reducers'
import SaadaCoinAgencyRecharge from '../pages/saada/Coinagency/AgencyRecharge/reducers'
import SaadaCoinAgencyDistributorManage from '../pages/saada/Coinagency/DistributorManage/reducers'
import SaadaCoinAgencyDistributorManageSuper from '../pages/saada/Coinagency/DistributorManageSuper/reducers'
import SaadaDistributorUserConfirm from '../pages/saada/Coinagency/DistributorUserConfirm/reducers'
import SaadaFlare from '../pages/saada/Flare/reducers'
import SaadaNewCoinagency from '../pages/saada/Coinagency/pages/reducers'
import SaadaBuyCoin from '../pages/saada/BuyCoin/reducers'
import SaadaGrowthCenter from '../pages/saada/GrowthCenter/reducers'
import SaadaCreditCardRecharge from '../pages/saada/CreditCardRecharge/reducers'
import SaadaKingKong from '../pages/saada/KingKong/reducers'

export default {
  CertificationAppeals,
  Animal_Puppy: SaadaFirstCharge,
  SaadaBDCenter,
  Animal_Quokka: SaadaUnionCenter,
  SaadaUnionAnchorInvite,
  SaadaAnchorGuideCenter,
  SaadaAnchorJoinUnion,
  Animal_Beaver: SaadaWalletHome,
  Animal_Squirrel: SaadaWalletOutCash,
  SaadaUnionWelcome,
  SaadaLevelCenter,
  Animal_Bee: SaadaChatIncome,
  Animal_Wolf: SaadaChatRank,
  SaadaRecScore,
  Animal_Lemur: SaadaUnionExportRevenue,
  SaadaUnionDeleteAnchor,
  Animal_Orca: SaadaAgency,
  Animal_Chameleon: SaadaAnonymousMatching,
  Animal_Doe: SaadaFemaleUserWelcome,
  Animal_Stoat: SaadaCoinAgencyWallet,
  Animal_Fox: SaadaCoinAgencyRecharge,
  Animal_Mongoose: SaadaCoinAgencyDistributorManage,
  Animal_Kangaroo: SaadaCoinAgencyDistributorManageSuper,
  SaadaDistributorUserConfirm,
  SaadaFlare,
  Animal_Nightingale: SaadaNewCoinagency,
  Animal_Magpie: SaadaBuyCoin,
  SaadaGrowthCenter,
  Animal_Hawk: SaadaCreditCardRecharge,
  SaadaKingKong,
}
